<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.getTruckers();
        payload.filter();
    },
    methods:{
        getTruckers: function(){
            Request.do(this, 'POST', Request.getDefaultHeader(this), {type: "USER-CUSTOMER"}, `${Endpoints.systemUsers.ListUserByType}`,
            (response)=>{//SUCCESS CALLBACK
                this.truckers = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        save: function(){
            if(this.data.trucker && this.data.trucker._id.length > 0){
                Request.do(this, 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.healths.health}`,
                (response)=>{//SUCCESS CALLBACK
                this.$fire({
                    text: this.$t('str.health.post.sucess'),
                    type: "success",
                    timer: 2000
                        }).then(() => {
                            this.items.push(this.data);
                            this.json_data = this.items;
                            this.filter();
                    }); 
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }else{
                this.errors.push(this.$t('response.health.trucker.required'));
            }
        },
        selectItem: function(item){
            if(item){
                $('#spinner').modal('toggle');
                Request.do(this, 'POST', Request.getDefaultHeader(this), {trucker: item._id }, `${Endpoints.healths.filter}`,
                (response)=>{//SUCCESS CALLBACK
                    this.items = response.results;
                    this.data.date = new Date();
                    this.data.systolicPressure = null;
                    this.data.diastolicPressure = null;
                    this.data.abdominalWaist = null;
                    this.data.temperature =null;
                    this.data.saturation = null;
                    this.data.diabetes = false;
                    this.data.bloodGlucose = null;
                    this.data.obs = null;
                    this.data.status = "ACTIVE";
                    $('#spinner').modal('toggle');  
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
                this.json_data = this.items;
            }
        }, 
        filter: function(){
            Request.do(this, 'POST', Request.getDefaultHeader(this), {}, `${Endpoints.healths.filter}`,
            (response)=>{//SUCCESS CALLBACK
                this.items = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
            this.json_data = this.items;
        }, 
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        customLabelTrucker(option) {
            return `${option.firstName + ' ' + option.lastName + ' - Telefone: ' + option.primaryPhone}`
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
